import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import * as _ from 'lodash';
import { IProject } from "./projects.interface";
import { HttpService } from "../../../../http.service";
import { UtilsService } from "../../../shared/services/utils.service";
import { AuthService } from "../../../shared/services/auth.service";
import { IFilter } from "../../../shared/interfaces/filter.interface";
import { apiURL, EnvConfig } from "../../../../env-config";

@Injectable()
export class ProjectsHttpService {
  constructor(
    private _http: HttpService,
    private _utilsService: UtilsService,
    private _AuthService: AuthService
  ) { }

  getProjects(filter?: IFilter): Observable<IProject[]> {
    let queryParams: string = !_.isEmpty(filter) ? '?' + this._utilsService.toQueryString(filter) : '';
    return this._http.get(`${apiURL(EnvConfig.API_PROJECTS)}${queryParams}`)
  }

  getProject(project: any | string): Observable<IProject> {
    let id = (typeof project == 'string') ? project : project._id;
    return this._http.get(`${apiURL(EnvConfig.API_PROJECTS)}/${id}`);
  }

  createProject(project: IProject): Observable<IProject> {
    return this._http.post(`${apiURL(EnvConfig.API_PROJECTS)}`, project);
  }

  updateProject(project: IProject): Observable<any> {
    let id = project._id;
    delete project._id;
    return this._http.patch(`${apiURL(EnvConfig.API_PROJECTS)}/${id}`, project);
  }

  deleteProject(project: IProject | string, hardDelete: boolean = false): Observable<void> {
    let id = (typeof project == 'string') ? project : project._id;
    if (hardDelete) return this._http.delete(`${apiURL(EnvConfig.API_PROJECTS)}/${id}`);
    return this._http.delete(`${apiURL(EnvConfig.API_PROJECTS)}/${id}/delete`);
  }

  restoreProject(project: IProject | string): Observable<void> {
    let id = (typeof project == 'string') ? project : project._id;
    return this._http.post(`${apiURL(EnvConfig.API_PROJECTS)}/${id}/restore`, null);
  }
}